<template>
    <div style="max-width: 560px">
        <form class="container" @submit.prevent="checkContent">
            <div class="form-group row">
                <label for="inputFullname" class="col-sm-2 col-form-label"
                >姓名</label
                >
                <div class="col-sm-10">
                    <input
                        type="text"
                        class="form-control"
                        id="inputFullname"
                        v-model="myUser.name"
                    />
                </div>
            </div>
            <div class="form-group row">
                <label for="inputEmail" class="col-sm-2 col-form-label"
                >E-mail</label
                >
                <div class="col-sm-10">
                    <input
                        type="email"
                        class="form-control"
                        :class="emailCheck"
                        id="inputEmail"
                        v-model="myUser.email"
                    />
                </div>
            </div>
            <div class="form-group row">
                <label for="inputPhone" class="col-sm-2 col-form-label"
                >Phone</label
                >
                <div class="col-sm-10">
                    <input
                        type="phone"
                        class="form-control"
                        :class="phoneCheck"
                        id="inputPhone"
                        v-model="myUser.phone"
                    />
                </div>
            </div>
            <div class="form-group row">
                <label for="inputPassword" class="col-sm-2 col-form-label"
                >密碼</label
                >
                <div class="col-sm-10">
                    <input
                        type="password"
                        class="form-control"
                        :class="passwordCheck"
                        id="inputPassword"
                        v-model="myUser.password"
                    />
                </div>
            </div>
            <div class="form-group row">
                <label
                    for="inputPasswordConfirm"
                    class="col-sm-2 col-form-label"
                >密碼確認</label
                >
                <div class="col-sm-10">
                    <input
                        type="password"
                        class="form-control"
                        :class="passwordCheck"
                        id="inputPasswordConfirm"
                        v-model="myUser.passwordConfirm"
                    />
                </div>
            </div>
            <br/>
            信件地址
            <user-address
                :class="roadCheck"
                v-model="myUser.address"
            ></user-address>
            <br/>
            <div class="form-group row">
                <div class="col-sm-10">
                    <button type="submit" class="btn btn-primary">
                        Save
                    </button>
                    <button
                        type="button"
                        class="btn btn-secondary"
                        @click.prevent="goToCancel"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import ComponentAPIVue from "../../ComponentAPI.vue";

export default {
    extends: ComponentAPIVue,
    props: {
        cancelUrl: {
            default: `${base_url}/admin/customers`
        },
        userId: {
            default: undefined
        }
    },
    data() {
        return {
            apiUrl: `${base_url}/admin/api/customers`,
            myUser: this.defaultUser()
        };
    },
    mounted() {
        if (this.userId) {
            this.apiUrl = `${this.apiUrl}/${this.userId}`
            this.loadUserData();
        }
    },
    methods: {
        checkContent(...args) {
            let response_promise;
            this.myUser.address.address = this.myUser.address.road;
            if (this.userId) response_promise = this.apiUpdate(this.myUser);
            else response_promise = this.apiPost(this.myUser);
            response_promise
                .then(user => {
                    console.log('have you got this?');
                    this.goToCancel();
                    return false;
                })
                .catch(error => {
                    window.alert('Some thing is going wrong.');
                    return false;
                });
        },
        defaultUser() {
            return {
                name: undefined,
                email: undefined,
                phone: undefined,
                password: undefined,
                passwordConfirm: undefined,
                address: {}
            };
        },
        loadUserData() {
            this.apiGet(`${base_url}/admin/api/customers/${this.userId}`)
                .then(user => {
                    user.address.road = user.address.address;
                    this.myUser = user;
                })
                .catch(console.log);
        }
    },
    computed: {
        passwordCheck() {
            return {
                "border-danger":
                    this.myUser.password &&
                    this.myUser.passwordConfirm &&
                    this.myUser.password !== this.myUser.passwordConfirm,
            };
        },
        emailCheck() {
            return {
                "border-danger":
                    this.myUser.email &&
                    (typeof this.myUser.email !== "string" ||
                        !/[a-z0-9\.\-]+@([a-z0-9\-]+\.)+([a-z0-9\-]+)$/.test(
                            this.myUser.email.toLowerCase()
                        )),
            };
        },
        phoneCheck() {
            let telephone_rule = /^[0-9\#\(\)\-]+$/,
                cellphone_rule = /^09[0-9]{8}$/;
            return {
                "border-danger":
                    this.myUser.phone &&
                    (typeof this.myUser.phone !== "string" ||
                        !cellphone_rule.test(this.myUser.phone.toLowerCase())),
            };
        },
        roadCheck() {
            return {
                border: true,
                "border-danger":
                    this.myUser.address.road &&
                    !(this.myUser.address.road.length > 1),
            };
        },
    },
};
</script>
<style lang="">
</style>
